import { selectAll, on, addClass, removeClass, hasClass, getData, select, setStyle, setAttribute } from 'modules/dom'
import { map, pipe } from 'modules/utils'
import debounce from 'lodash.debounce';
const Accordion = function (el) {
  const toggles = selectAll('.js-toggle', el)
  const items = selectAll('.js-item', el)
  const contentList = selectAll('.js-content', el)
  const ACTIVATE_ITEM_CLASS = getData('activate-class', el)

  if (ACTIVATE_ITEM_CLASS && items && toggles) {
    const activateItem = pipe(addClass(ACTIVATE_ITEM_CLASS), setAttribute('aria-expanded', true))
    const deactivateItem = pipe(removeClass(ACTIVATE_ITEM_CLASS), setAttribute('aria-expanded', false))
    const setMaxHeight = setStyle('max-height')
    const setHeight = (item) => {
      const height = item.scrollHeight + 'px'
      setMaxHeight(height, item)
    }
    const resetHeight = (item) => map(setMaxHeight(0), item)

    const setHeightParent = (item) => {
      const parent = item.closest('.js-accordion-sidebar-content')
      if (parent) {
        const parentHeight = (parent.scrollHeight + item.scrollHeight) + 'px'
        setMaxHeight(parentHeight, parent)
      }
    }
    const resetHeightParent = (item) => {
      const parent = item.closest('.js-accordion-sidebar-content')
      if (parent) {
        const parentHeight = (parent.scrollHeight - item.scrollHeight) + 'px'
        setMaxHeight(parentHeight, parent)
      }
    }

    const findParent = (toggle) => toggle.parentNode
    const initUpdate = (toggle) => {
      const item = findParent(toggle)
      const content = select('.js-content', item)
      if (!hasClass(ACTIVATE_ITEM_CLASS, item)) {
        map(deactivateItem, items)
        activateItem(item)
        resetHeight(contentList)
        setHeight(content)
        setHeightParent(content)
      } else {
        deactivateItem(item)
        resetHeight(content)
        resetHeightParent(content)
      }
    }

    const activeFilterButtons = (sidebarEl) => {
      if (sidebarEl) {
        const checkedCheckboxes = selectAll('.js-field__checkbox > input:checked', sidebarEl)
        const checkedRadios = selectAll('.js-field__radio > input:checked', sidebarEl)
        const filterButtons = selectAll('.js-field-filter-buttons', sidebarEl)
        const filterClearMobileEl = select('.js-sidebar-button-filter-clear', sidebarEl)
        const sidebarToggleCountEl = select('.js-sidebar-toggle-count', sidebarEl)
        if (checkedCheckboxes.length > 0 || checkedRadios.length > 0) {
          const countAll = checkedCheckboxes.length + checkedRadios.length
          if (sidebarToggleCountEl) {
            sidebarToggleCountEl.innerHTML = ' (' + countAll + ')'
          }
          if (filterButtons.length > 0) {
            map(filterButton => {
              const buttonEl = select('button', filterButton)
              if (buttonEl) {
                buttonEl.disabled = false
              }
              addClass('active', filterButton)
            }, filterButtons)
          }
          if (filterClearMobileEl) {
            addClass('active', filterClearMobileEl)
          }
        } else {
          if (sidebarToggleCountEl) {
            sidebarToggleCountEl.innerHTML = ''
          }
          if (filterButtons.length > 0) {
            map(filterButton => {
              const buttonEl = select('button', filterButton)
              if (buttonEl) {
                buttonEl.disabled = true
              }
              removeClass('active', filterButton)
            }, filterButtons)
          }
          if (filterClearMobileEl) {
            removeClass('active', filterClearMobileEl)
          }
        }
      }
    }

    const countItemsChecked = (parent, parentList) => {
      // count checked list in item
      if (parent) {
        const itemsEl = selectAll('.js-item input:not([data-value="all"]):checked', parent)
        const countEl = select('.js-count', parent)
        if (itemsEl.length > 0) {
          countEl.innerHTML = ' (' + itemsEl.length + ')'
        } else {
          countEl.innerHTML = ''
        }
      }
      // count checked list in item accordion
      if (parentList) {
        const parentItems = selectAll('.js-accordion-sidebar-item input:not([data-value="all"]):checked', parentList)
        const countParentListEl = select('.js-count', parentList)
        if (parentItems.length > 0) {
          countParentListEl.innerHTML = ' (' + parentItems.length + ')'
        } else {
          countParentListEl.innerHTML = ''
        }
      }
    }

    const checkedChildItems = (sidebarEl, inputParentEl) => {
      if (inputParentEl) {
        const target = inputParentEl
        const parent = target.closest('.js-item')
        const parentList = target.closest('.js-accordion-sidebar-item')
        const checkboxes = selectAll('input[type="checkbox"]', parent)
        if (target.checked) {
          map(item => { item.checked = true }, checkboxes)
        } else {
          map(item => { item.checked = false }, checkboxes)
        }
        activeFilterButtons(sidebarEl)
        countItemsChecked(parent, parentList)

        const parentSearchForm = target.closest('.js-search-resource-filter-form')
        activeFilterButtons(parentSearchForm)
        const parentSearch = target.closest('.search-resource__item')
        countItemSearchChecked(parentSearch)
      }
    }

    const countItemSearchChecked = (parentSearch) => {
      if (parentSearch) {
        const countTextEl = select('.js-resource-concepts-select-text', parentSearch)
        const countEl = select('.js-count', parentSearch)
        const inputChecked = selectAll('input:not([data-value="all"]):checked', parentSearch)
        if (inputChecked.length > 0) {
          countTextEl.innerHTML = '(' + inputChecked.length + ')'
          countEl.innerHTML = '(' + inputChecked.length + ')'
        } else {
          countTextEl.innerHTML = ''
          countEl.innerHTML = ''
        }
      }
    }

    const uncheckedParent = (sidebarEl, inputChildEl) => {
      if (inputChildEl) {
        const target = inputChildEl
        const parent = target.closest('.js-item')
        const parentList = target.closest('.js-accordion-sidebar-item')
        if (parent) {
          const itemHeadingEl = select('.js-toggle', parent)
          const parentCheckbox = select('input[type="checkbox"]', itemHeadingEl)
          const childCheckboxes = selectAll('.js-field__checkbox > input[type="checkbox"]', parent)
          const childCheckBoxesIsChecked = selectAll('.js-field__checkbox > input[type="checkbox"]:checked', parent)
          if (childCheckboxes.length === childCheckBoxesIsChecked.length) {
            parentCheckbox.checked = true
          } else {
            parentCheckbox.checked = false
          }
          if (childCheckBoxesIsChecked.length > 0 && childCheckboxes.length !== childCheckBoxesIsChecked.length) {
            addClass('unchecked', parentCheckbox)
          } else {
            removeClass('unchecked', parentCheckbox)
          }
          activeFilterButtons(sidebarEl)
          countItemsChecked(parent, parentList)

          const parentSearchForm = target.closest('.js-search-resource-filter-form')
          activeFilterButtons(parentSearchForm)
          const parentSearch = target.closest('.search-resource__item')
          countItemSearchChecked(parentSearch)
        }
      }
    }

    on('click', function () {
      initUpdate(this)
    }, toggles)
    on('keydown', function (e) {
      if (e.keyCode == 13 || e.which == 13) {
        const toggle = select('.js-toggle', this)
        if (e.target == toggle) {
          initUpdate(toggle)
        }
      }
      if (e.keyCode == 32 || e.which == 32) {
        const target = e.target
        const sidebarEl = target.closest('.js-sidebar')
        // parent checkbox handle
        const inputParentEl = select('input[data-value="all"]', target)
        if (sidebarEl && inputParentEl) {
          e.stopPropagation()
          if (!inputParentEl.checked) {
            inputParentEl.checked = true
            if (hasClass('unchecked', inputParentEl)) {
              removeClass('unchecked', inputParentEl)
            }
          } else {
            inputParentEl.checked = false
          }
          checkedChildItems(sidebarEl, inputParentEl)
          e.preventDefault()
        }

        const searchFormEl = target.closest('.js-search-resource-filter-form')
        if (searchFormEl) {
          const inputChildEl = select('input:not([data-value="all"])', target)
          if (inputChildEl) {
            if (!inputChildEl.checked) {
              inputChildEl.checked = true
              if (hasClass('unchecked', inputChildEl)) {
                removeClass('unchecked', inputChildEl)
              }
            } else {
              inputChildEl.checked = false
            }
            uncheckedParent(sidebarEl, inputChildEl)
            e.preventDefault()
          }

          const inputParentEl = select('input[data-value="all"]', target)
          if (inputParentEl) {
            if (!inputParentEl.checked) {
              inputParentEl.checked = true
              if (hasClass('unchecked', inputParentEl)) {
                removeClass('unchecked', inputParentEl)
              }
            } else {
              inputParentEl.checked = false
            }
            checkedChildItems(sidebarEl, inputParentEl)
            e.preventDefault()
          }
        }
      }
    }, items)

    const resetHeightToggle = () => {
      if (toggles.length > 0) {
        map(toggle => {
          const item = findParent(toggle)
          const content = select('.js-content', item)
          deactivateItem(item)
          resetHeight(content)
        }, toggles)
      }
    }
    on('resize', debounce(resetHeightToggle), window)
  }
}

export default Accordion
